import { Component, OnInit } from '@angular/core';
import { AuthService, Category } from '../auth.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-categories',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './categories.component.html',
  styleUrl: './categories.component.css'
})
export class CategoriesComponent implements OnInit {
  categories: Category[] = [];
  selectedCategory: Category = { id: 0, title: '', slug: '', specs: '' };
  selectedImageFile: File | null = null;
  errorMessage: string = '';
  isUpdating: boolean = false; // Flag to determine if we're updating

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.loadCategories();
  }

  // Charger toutes les catégories
  loadCategories(): void {
    this.authService.getCategories().subscribe(
      (data: Category[]) => {
        this.categories = data;
      },
      error => {
        this.errorMessage = 'Erreur lors de la récupération des catégories.';
      }
    );
  }

  // Gérer la sélection d'une image
  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (file) {
      this.selectedImageFile = file;
    }
  }
  generateSlug(title: string): string {
    return title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-+|-+$)/g, '');
  }

  // Ajouter ou mettre à jour une catégorie
  saveCategory(): void {
    if (this.selectedCategory.title && this.selectedCategory.slug && this.selectedCategory.specs) {
      const formData: FormData = new FormData();
      formData.append('title', this.selectedCategory.title);
      formData.append('slug', this.generateSlug(this.selectedCategory.title));
      formData.append('specs', this.selectedCategory.specs);

      if (this.selectedImageFile) {
        formData.append('image', this.selectedImageFile);
      }

      if (this.isUpdating) {
        this.authService.updateCategory(this.selectedCategory.id, formData).subscribe(
          () => {
            this.loadCategories();
            this.resetForm();
          },
          error => {
            this.errorMessage = 'Error updating category.';
          }
        );
      } else {
        this.authService.createCategory(formData).subscribe(
          () => {
            this.loadCategories();
            this.resetForm();
          },
          error => {
            this.errorMessage = 'Error adding category.';
          }
        );
      }
    } else {
      this.errorMessage = 'Please fill in all fields.';
    }
  }

  // Réinitialiser le formulaire
  resetForm(): void {
    this.selectedCategory = { id: 0, title: '', slug: '', specs: '' };
    this.selectedImageFile = null;
    this.isUpdating = false; // Reset update flag
  }

  // Préparer le formulaire pour la mise à jour
  editCategory(category: Category): void {
    this.selectedCategory = { ...category };
    this.isUpdating = true; // Set flag to true for update
  }

  // Supprimer une catégorie
  deleteCategory(id: number): void {
    this.authService.deleteCategory(id).subscribe(
      () => {
        this.loadCategories();
      },
      error => {
        this.errorMessage = 'Error deleting category.';
      }
    );
  }

  // Utiliser la méthode du service pour obtenir l'URL de l'image
  getImageUrl(fileName: string): string {
    return this.authService.getImageUrl(fileName);
  }
}
